<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm6>
                    <div>
                        <v-btn @click="newPlibel" large color="primary">Nueva hoja</v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <br>
            <v-layout>
                <v-flex xs12 sm6 offset-sm1>
                    <v-select v-model="ergo" :items="this.listErgo" @change="loadCalculate()" label="Historial" item-text="fecha" return-object
                              required></v-select>
                </v-flex>
            </v-layout>
            <br>
            <v-expansion-panel v-if="this.ergo!=null">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 1. Información personal y laboral</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.ergo.informacionLaboral"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==20" class="font-weight-bold">a. Datos de filiación</p>
                                        <p v-if="props.item.tipo==21" class="font-weight-bold">Identificación: {{$store.state.patient.identification}}</p>
                                        <p v-if="props.item.tipo==22" class="font-weight-bold">Apellidos y nombres: {{$store.state.patient.firstLastName}} {{$store.state.patient.secondLastName}}  {{$store.state.patient.firstName}} {{$store.state.patient.secondName}} </p>
                                        <p v-if="props.item.tipo==23" class="font-weight-bold">Edad: {{$store.state.patient.age}}</p>
                                        <p v-if="props.item.tipo==24" class="font-weight-bold">Empresa: {{$store.state.patient.company.name}}</p>
                                        <p v-if="props.item.tipo==25" class="font-weight-bold">Puesto de trabajo: {{$store.state.patient.jobCompany}}</p>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 2. Ergo</div>
                    </template>
                    <table>
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCFF" width="1500px"><b>INSTRUMENTO ERGO-PVDs
                                Inscora</b></td>
                        </tr>
                        <tr>
                            <td colspan="2" bgcolor="#CCAFFF" width="1500px"><b>Pantalla</b></td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Se puede mover el monitor en todas las direcciones?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch1"
                                          :label="`${this.ergo.switch1 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Está a una altura adecuada? (115 cm- 120 cm)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch2"
                                          :label="`${this.ergo.switch2 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Son los caracteres fácilmente legibles? (3mm)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch3"
                                          :label="`${this.ergo.switch3 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Hay parpadeo en alguna zona de la pantalla?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch4"
                                          :label="`${this.ergo.switch4 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Se puede ajustar el brillo y el contraste?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch5"
                                          :label="`${this.ergo.switch5 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Se producen reflejos en la pantalla?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch6"
                                          :label="`${this.ergo.switch6 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Se puede limpiar con facilidad?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch7"
                                          :label="`${this.ergo.switch7 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Está el monitor bien colocado con relación a las ventanas y fuentes de
                                luz artificial? (que no refleje)
                            </td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch8"
                                          :label="`${this.ergo.switch8 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">Ángulo del monitor (15º)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch9"
                                          :label="`${this.ergo.switch9 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">Distancia ojo-monitor (65-75 cm)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch10"
                                          :label="`${this.ergo.switch10 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" bgcolor="#CCAFFF" width="1500px"><b>Porta documentos</b></td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Está a la altura adecuada en relación con la pantalla?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch11"
                                          :label="`${this.ergo.switch11 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Es ajustable en todas las direcciones?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch12"
                                          :label="`${this.ergo.switch12 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" bgcolor="#CCAFFF" width="1500px"><b>Teclado</b></td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Está separado del equipo y es ajustable? (0-25º)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch13"
                                          :label="`${this.ergo.switch13 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Son las teclas fácilmente legibles?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch14"
                                          :label="`${this.ergo.switch14 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Tiene la superficie mate?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch15"
                                          :label="`${this.ergo.switch15 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Hay espacio suficiente entre el teclado y el borde de la mesa?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch16"
                                          :label="`${this.ergo.switch16 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Dispone de reposamanos?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch17"
                                          :label="`${this.ergo.switch17 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" bgcolor="#CCAFFF" width="1500px"><b>Iluminación</b></td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Hay suficiente luz natural? (300-1000 lux)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch18"
                                          :label="`${this.ergo.switch18 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Disponen las ventanas de persianas o cortinas?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch19"
                                          :label="`${this.ergo.switch19 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Se producen reflejos o deslumbramientos por luz natural o artificial?
                            </td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch20"
                                          :label="`${this.ergo.switch20 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Es adecuada la luz artificial? (300-1000 lux)
                            </td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch21"
                                          :label="`${this.ergo.switch21 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Se puede regular la cantidad de luz del puesto de trabajo?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch22"
                                          :label="`${this.ergo.switch22 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Se dispone de lámpara de mesa?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch23"
                                          :label="`${this.ergo.switch23 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Se dispone de pantalla antirreflectante?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch24"
                                          :label="`${this.ergo.switch24 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>

                        <tr>
                            <td width="1500px" bgcolor="#CCAFFF"><b>PUNTAJE SUBTOTAL (Ergonomía visual):</b></td>
                            <td width="500px"><input id="puntaje1" type="text" name="q1" :value="this.calculo1"></td>
                        </tr>
                        <tr>
                            <td colspan="6"><input type="button" @click="calculoItem1()" value="CALCULAR"></td>
                        </tr>


                        <tr>
                            <td colspan="2" bgcolor="#CCAFFF" width="1500px"><b>Mesa de trabajo</b></td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Tiene una altura adecuada? (65-75 cm)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch25"
                                          :label="`${this.ergo.switch25 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Es ésta ajustable?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch26"
                                          :label="`${this.ergo.switch26 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Es suficiente el área de la mesa de trabajo? (90-120 cm)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch27"
                                          :label="`${this.ergo.switch27 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Hay espacio suficiente para las piernas? (60 cm de ancho x 65/70 cm de
                                profundidad)
                            </td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch28"
                                          :label="`${this.ergo.switch28 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Hay obstáculos bajo el plano de la mesa?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch29"
                                          :label="`${this.ergo.switch29 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Dispone de reposapies? (35 x 45 cm)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch30"
                                          :label="`${this.ergo.switch30 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" bgcolor="#CCAFFF" width="1500px"><b>Silla</b></td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Es ajustable en altura? (45-55 cm)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch31"
                                          :label="`${this.ergo.switch31 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Dispone de respaldo ajustable? (20-30 cm)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch32"
                                          :label="`${this.ergo.switch32 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Tiene una base estable? (5 patas)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch33"
                                          :label="`${this.ergo.switch33 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Presiona el asiento en el muslo o parte posterior de la rodilla?
                            </td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch34"
                                          :label="`${this.ergo.switch34 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Se dispone de espacio suficiente para la silla?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch35"
                                          :label="`${this.ergo.switch35 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Se puede cambiar de posición y realizar movimientos?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch36"
                                          :label="`${this.ergo.switch36 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="2" bgcolor="#CCAFFF" width="1500px"><b>Electricidad</b></td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Están los enchufes e interruptores en buenas condiciones?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch37"
                                          :label="`${this.ergo.switch37 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Hay enchufes sobrecargados?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch38"
                                          :label="`${this.ergo.switch38 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Están los cables protegidos?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch39"
                                          :label="`${this.ergo.switch39 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" bgcolor="#CCAFFF" width="1500px"><b>Entorno</b></td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Hay una temperatura confortable?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch40"
                                          :label="`${this.ergo.switch40 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Hay una humedad adecuada?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch41"
                                          :label="`${this.ergo.switch41 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Hay ruido procedente de otros equipos? (40-55dB)</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch42"
                                          :label="`${this.ergo.switch42 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Hay ruido procedente de la calle? (40-55dB)
                            </td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch43"
                                          :label="`${this.ergo.switch43 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Hay humos o gases procedentes de equipos próximos?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch44"
                                          :label="`${this.ergo.switch44 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Hay exceso de radiación del monitor o de otros próximos?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch45"
                                          :label="`${this.ergo.switch45 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" bgcolor="#CCAFFF" width="1500px"><b>Software</b></td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Es adecuado a la tarea?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch46"
                                          :label="`${this.ergo.switch46 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Es fácil de usar?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch47"
                                          :label="`${this.ergo.switch47 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Aparece la información en un formato y velocidad adecuados?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch48"
                                          :label="`${this.ergo.switch48 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Permite un control sobre la cantidad y calidad del trabajo que se
                                realiza?
                            </td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch49"
                                          :label="`${this.ergo.switch49 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px">¿Se da una adecuada formación al usuario?</td>
                            <td width="500px">
                                <v-switch v-model="ergo.switch50"
                                          :label="`${this.ergo.switch50 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td width="1500px" bgcolor="#CCAFFF"><b>PUNTAJE (Ergonomía e higiene general):</b></td>
                            <td width="500px"><input id="puntaje2" type="text" name="q2" :value="this.calculo3"></td>
                        </tr>
                        <tr>
                            <td width="1500px" bgcolor="#CCAFFF"><b>PUNTAJE:</b></td>
                            <td width="500px"><input id="puntaje" type="text" name="q3" :value="this.calculo2"></td>
                        </tr>
                        <tr>
                            <td colspan="6"><input type="button" @click="calculoItem2()" value="CALCULAR"></td>
                        </tr>
                        </tbody>
                    </table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-form>
        <div class="text-xs-center" v-if="ergo!=null">
            <v-btn color="primary" @click="deleteForm" dark>Eliminar Registro</v-btn>
            <v-btn color="primary" @click="savePlibel" dark>Guardar</v-btn>
        </div>
        <v-dialog
                v-model="dialogError"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor verifique la información requerida para continuar.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogError = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogSuccess = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import Ergo from "../../../model/Ergo"
    import PatientMonitoring from "../../../model/PatientMonitoring";

    export default {
        data() {
            return {
                ergo: null,
                listErgo: [],
                valid: true,
                search: '',
                dialogError: false,
                dialogSuccess: false,
                calculo1: 0,
                calculo2: 0,
                calculo3: 0


            }
        },
        methods: {

            newPlibel() {
                let d = new Date();
                let e = this.formatDate(d);
                console.log(this.ergo)
                this.ergo = new Ergo();
                console.log(this.ergo)
                this.ergo.fecha = e
                this.listErgo.push(this.ergo)
            },
            savePlibel() {
                if (this.$refs.form.validate()) {
                    this.$store.state.patientMonitoringList = []
                    if (this.ergo.id != '' && this.ergo.id != null) {
                        this.$store.dispatch('getPatientMonitoring', this.ergo.id).then(response => {
                            this.$store.state.patientMonitoringOne.value = JSON.stringify(this.ergo)
                            this.$store.dispatch('updatePatientMonitoring', this.$store.state.patientMonitoringOne).then(response => {
                                this.dialogSuccess = true
                                this.reloadData()
                            }, error => {
                                this.$store.state.progress = false
                                this.$store.state.dialogError = true
                            })
                        })
                    } else {
                        let monitoringNew = new PatientMonitoring()
                        monitoringNew.date = new Date()
                        monitoringNew.value = JSON.stringify(this.ergo)
                        monitoringNew.form = 59
                        monitoringNew.patientRouteSheet = this.$store.state.routeSheet
                        this.$store.dispatch('addPatientMonitoring', monitoringNew).then(response => {
                            this.dialogSuccess = true
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                } else {
                    this.dialogError = true
                }
            },
            calculoItem1(){
                this.calculo1 = 0
                this.calculo1 = this.calculo1+(this.ergo.switch1===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch2===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch3===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch4===true?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch5===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch6===true?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch7===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch8===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch9===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch10===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch11===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch12===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch13===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch14===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch15===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch16===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch17===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch18===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch19===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch20===true?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch21===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch22===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch23===false?1:0)
                this.calculo1 = this.calculo1+(this.ergo.switch24===false?1:0)

            },


            calculoItem2(){
                this.calculo2 = 0
                this.calculo2 = this.calculo2+(this.ergo.switch1===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch2===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch3===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch4===true?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch5===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch6===true?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch7===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch8===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch9===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch10===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch11===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch12===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch13===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch14===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch15===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch16===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch17===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch18===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch19===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch20===true?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch21===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch22===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch23===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch24===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch25===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch26===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch27===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch28===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch29===true?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch30===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch31===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch32===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch33===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch34===true?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch35===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch36===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch37===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch38===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch39===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch40===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch41===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch42===true?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch43===true?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch44===true?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch45===true?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch46===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch47===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch48===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch49===false?1:0)
                this.calculo2 = this.calculo2+(this.ergo.switch50===false?1:0)
                this.calculoItem3()

            },
            calculoItem3(){
                this.calculo3 = 0
                this.calculo3 = this.calculo3+(this.ergo.switch24===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch25===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch26===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch27===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch28===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch29===true?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch30===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch31===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch32===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch33===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch34===true?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch35===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch36===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch37===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch38===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch39===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch40===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch41===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch42===true?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch43===true?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch44===true?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch45===true?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch46===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch47===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch48===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch49===false?1:0)
                this.calculo3 = this.calculo3+(this.ergo.switch50===false?1:0)

            },

            loadCalculate(){
                this.calculoItem1();
                this.calculoItem2();
                this.calculoItem3();
            },
            deleteForm(){
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deletePatientMonitoring',this.ergo.id).then(response => {
                    this.reloadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            formatDate(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ":" + seconds + ' ' + ampm;
                return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            },
            reloadData() {
                let data = new PatientMonitoring()
                data.form = 59
                data.patientRouteSheet = this.$store.state.routeSheet
                data.date = new Date()
                data.value = ""
                this.ergo = null
                this.$store.dispatch('getPatientMonitoringByRouteSheetForm', data).then(response => {
                    this.listErgo = []
                    for (let i = 0; i < this.$store.state.patientMonitoringList.length; i++) {
                        let anam = JSON.parse(this.$store.state.patientMonitoringList[i].value)
                        anam.id = this.$store.state.patientMonitoringList[i].id
                        this.listErgo.push(anam)
                    }
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },

        },
        computed: {},
        created() {
            this.reloadData()
        },
    }
</script>

<style scoped>
    v-switch {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/patient/oftalmologico/Ergo.vue